// Re-export types for compatibility
export type { Translation } from './types';

// Dynamic import functions for lazy loading
export const loadTranslation = async (lang: 'es' | 'en' | 'pt' | 'fr') => {
  switch (lang) {
    case 'es':
      return (await import('./es')).es;
    case 'en':
      return (await import('./en')).en;
    case 'pt':
      return (await import('./pt')).pt;
    case 'fr':
      return (await import('./fr')).fr;
    default:
      return (await import('./es')).es;
  }
};

// For backwards compatibility - synchronous access
// Components should migrate to useTranslations() hook
import { es } from './es';
import { en } from './en';
import { pt } from './pt';
import { fr } from './fr';
import { Translation } from './types';

export const translations: Record<string, Translation> = {
  es,
  en,
  pt,
  fr
};
